angular.module('zc.zenclerkS')
  .component('zcsCampaignEditStepDelivery', {
    templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_delivery.html',
    bindings: {
      liteSamplingRanges: '<',
    },
    require: {
      campaignEdit: '^zcsCampaignEdit'
    },
    controller: ZcsCampaignEditStepDeliveryController
  });

ZcsCampaignEditStepDeliveryController.$inject = ['$state', 'ZcsTiming', 'ZcsOemService', 'currencies'];
function ZcsCampaignEditStepDeliveryController($state, ZcsTiming, ZcsOemService, currencies) {
  const vm = this;

  vm.ZcsOemService = ZcsOemService;

  this.$onInit = () => {
    vm.campaign = this.campaignEdit.campaign;
    vm.project = this.campaignEdit.project;

    // variables
    vm.timingPlans = ZcsTiming.timingPlans;
    vm.currency = currencies[vm.project.currency];
    vm.samplingRange = vm.campaign.sampling_range
      ? _.find(vm.liteSamplingRanges, { label: vm.campaign.sampling_range }).label
      : _.minBy(vm.liteSamplingRanges, 'name').label;

    // actions
    vm.isDisabled = isDisabled;
    vm.selectSamplingRange = selectSamplingRange;
    vm.selectTiming = selectTiming;

    // select first plan by default
    if(!vm.campaign.timing) {
      if(vm.campaign.segment.name === 'zcs_segment_mail_only') {
        selectTiming(vm.timingPlans[1]);
      } else {
        selectTiming(vm.timingPlans[0]);
      }
    }

    if(!vm.campaign.template_type) {
      $state.go('zenclerkS.project.campaign.edit.design', { apikey: vm.project.apikey, campaignId: vm.campaign.id });
    }
  };

  function isDisabled(plan) {
    if(plan.name === 'ai' && vm.campaign.segment.name === 'zcs_segment_mail_only') {
      return true;
    }
    return false;
  }

  function selectSamplingRange() {
    vm.campaign.configuration_type = 'sampling';
    vm.campaign.sampling_range = vm.samplingRange;
  }

  function deselectSamplingRange() {
    vm.campaign.configuration_type = 'csv_upload';
    vm.campaign.sampling_range = null;
  }

  function selectTiming(plan) {
    if(plan.name === 'ai') {
      selectSamplingRange();
    } else {
      deselectSamplingRange();
    }

    if(isDisabled(plan)) {
      return;
    }
    vm.campaign.timing = plan;
    // TODO: get rid if memo workflow and automatize instead
    vm.campaign.memo = angular.toJson(plan);
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit_step_delivery.js